import moment from 'moment';
import { useCallback, useState } from 'react';

const LABEL_DATE_FORMAT = 'DD-MMM YYYY';

const getDateFilter = (date = moment()) => {
  return {
    label: date.format('MMMM YYYY'),
    from: date.clone().startOf('month'),
    to: date.clone().endOf('month'),
  };
};

export const useDateFilter = () => {
  const [dateFilter, setDateFilter] = useState(getDateFilter());

  const handleDateFilterChange = useCallback((dates) => {
    setDateFilter({
      label: `${dates.from.format(LABEL_DATE_FORMAT)} to ${dates.to.format(LABEL_DATE_FORMAT)}`,
      isCustom: true,
      ...dates,
    });
  }, []);

  const handleResetDateFilter = useCallback(() => {
    setDateFilter(getDateFilter());
  }, []);

  const handleNextMonth = useCallback(() => {
    setDateFilter(getDateFilter(dateFilter.from.add(1, 'months')));
  }, [dateFilter.from]);

  const handlePreviousMonth = useCallback(() => {
    setDateFilter(getDateFilter(dateFilter.from.subtract(1, 'months')));
  }, [dateFilter.from]);

  return {
    dateFilter,
    setDateFilter,
    onDateFilterChange: handleDateFilterChange,
    onResetDateFilter: handleResetDateFilter,
    onNextMonth: handleNextMonth,
    onPreviousMonth: handlePreviousMonth,
  };
};
